import { CreateRouterOptions } from '@/typings/common'
import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'

import { lkStoreModule } from '@/store/modules/lk'
import { ADMIN_LK } from '@/helpers/enums/menu-folders'
import { DASHBOARD_COLLECTOR_ROUTES as ROUTES } from './utils'
import { collectorViewPermissions as Permissions } from '@/helpers/enums/permission-models'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_DASHBOARD_COLLECTOR } from './utils'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'dashboard',
    name: ROUTES.LAYOUT,
    beforeEnter(to, from, next) {
      const storeModule = lkStoreModule.context(options.store)
      const canEdit = storeModule.getters.$access(Permissions.edit, false)
      const canRead = storeModule.getters.$access(Permissions.read, false)
      if (!(canEdit && canRead)) {
        const location = {
          name: ADMIN_LK.name,
        }

        next(location)
        return
      }
      next()
    },
    redirect: { name: ROUTES.INDEX },
    meta: { authorized: true },
    component: {
      name: 'ViewDashboardCollectorLayout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.INDEX,
        component: (): PromiseVue => import(
          /* webpackChunkName: "dashboard-collector.index" */
          './DashboardCollectorIndex.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
